import DocumentPreviewSlideIn from './DocumentPreviewSlideIn';

export default DocumentPreviewSlideIn;
